import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InPlaceSelect from 'components/form/in_place_select';
import { ForumStore , GroupStore } from '@seedlang/stores';
import InPlaceImageUpload from 'components/form/in_place_image_upload';
import autobind from 'autobind-decorator';
import { AppUI } from '@seedlang/state';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

@observer
class ForumEdit extends React.Component {

  constructor(props) {
    super(props);
    ForumStore.getShow({ ids: {forumId: this.props.params.forumId }}, this.afterGetShow);
    GroupStore.getIndex();
  }

  @autobind afterGetShow(resp) {
    ForumStore.setShowData(resp);
  }

  render() {
    if (ForumStore.hasShowData) {
      return (
        <Stack gap='sm' alignItems='stretch'>
          <Grid columns={[3,3,3]}>
            <InPlaceText
              legend='Title'
              defaultValue={ForumStore.showDataField('title')}
              model='forums'
              field='title'
              id={ForumStore.showDataField('id')}
            />
            <InPlaceText
              legend='Slug'
              defaultValue={ForumStore.showDataField('slug')}
              model='forums'
              field='slug'
              id={ForumStore.showDataField('id')}
            />
            <InPlaceSelect
              legend='Group'
              includeBlank
              id={ForumStore.showData.id}
              value={ForumStore.showData.hasGroup && ForumStore.showData.group.id}
              model='forums'
              field='group_id'
              options={GroupStore.indexData.map(item => [item.id, item.name])}
            />
          </Grid>
          <Grid columns={4}>
            <InPlaceCheckbox
              legend='Only Admin Can Access'
              id={ForumStore.showData.id}
              value={ForumStore.showData.admin}
              model='forums'
              field='admin'
            />
            <InPlaceCheckbox
              legend='Only Moderator Can Access'
              id={ForumStore.showData.id}
              value={ForumStore.showData.moderator}
              model='forums'
              field='moderator'
            />
            <InPlaceCheckbox
              legend='Only Translator Can Access'
              id={ForumStore.showData.id}
              value={ForumStore.showData.translator}
              model='forums'
              field='translator'
            />
            <InPlaceCheckbox
              id={ForumStore.showData.id}
              value={ForumStore.showData.hideCreateDiscussionButton}
              model='forums'
              field='hide_create_discussion_button'
            />
            <InPlaceCheckbox
              legend='Show Filters'
              id={ForumStore.showData.id}
              value={ForumStore.showData.showFilters}
              model='forums'
              field='show_filters'
            />
            <InPlaceCheckbox
              legend='Highlight Unseen'
              id={ForumStore.showData.id}
              value={ForumStore.showData.highlightUnseen}
              model='forums'
              field='highlight_unseen'
            />
            <InPlaceImageUpload
              legend='Image'
              model='images'
              image={ForumStore.showData.image}
              querystring={{
                imageable_id: ForumStore.showData.id,
                imageable_type: 'Forum',
              }}
            />
            <InPlaceSelect
              legend='Language'
              includeBlank
              id={ForumStore.showData.id}
              value={ForumStore.showData.languageId}
              model='forums'
              field='language_id'
              options={AppUI.languageOptions}
            />
          </Grid>
          <InPlaceText
            legend='Description'
            inputType='textarea'
            defaultValue={ForumStore.showDataField('description')}
            model='forums'
            field='description'
            id={ForumStore.showDataField('id')}
          />
        </Stack>
      );
    }
    return <span />;
  }
}

export default ErrorBoundary(ForumEdit);
